/* eslint-disable react/prop-types */ // TODO: add props
import styles from './QuestionProgressIndicator.scss';

export const QuestionProgressIndicator = ({
  responded,
  reflected,
  questionTitle,
}) => {
  return (
    <div className={styles.indicatorBg} title={questionTitle}>
      <span
        className={`${styles.response} ${responded ? styles.complete : ''}`}
      />
      <span
        className={`${styles.reflection} ${reflected ? styles.complete : ''}`}
      />
    </div>
  );
};
